import { useEffect, useState } from "react";

/**
 * 
 * @param {*} delay 
 * @returns [input, setInputQuery]
 */
export function useDebounceInput(delay=800) {
    const [input, setInput] = useState(null);
    const [inputQuery, setInputQuery] = useState(null);

    useEffect(() => {
        const delayFn = setTimeout(() => setInput(inputQuery), delay);
        return () => clearTimeout(delayFn);
    }, [inputQuery, delay])

    return [input, setInputQuery];
}